import { useTheme } from 'styled-components'

import {
  PopularMakesTileContainer,
  PopularMakesTileImage,
  PopularMakesTileImageContainer,
} from '@/components/brp/styled'
import { LinkCustom } from '@/components/shared/link-custom/LinkCustom'
import { BodyText } from '@/ui/atoms/body-text'
import { Spacing } from '@/ui/atoms/spacing'

export type PopularMakesTileProps = {
  label: string
  imageSrc: string
  url: string
  onClick: (value: string) => void
}

export const PopularMakesTile = ({ label, url, imageSrc, onClick }: PopularMakesTileProps) => {
  const { spacing } = useTheme()

  const handleClick = () => {
    onClick(label)
  }

  return (
    <LinkCustom href={url} noStyle style={{ textDecoration: 'none' }} onClick={handleClick}>
      <PopularMakesTileContainer>
        <PopularMakesTileImageContainer>
          <PopularMakesTileImage srcImage={{ src: imageSrc }} alt={label} skipNextImage />
        </PopularMakesTileImageContainer>
        <Spacing mTop={spacing.default}>
          <BodyText textAlign="center">{label}</BodyText>
        </Spacing>
      </PopularMakesTileContainer>
    </LinkCustom>
  )
}
